<div class="legalLogoFloatingWrapper">
  <div class="legalLogoFloating">
    <img src="assets/logos/logo-black.svg" alt="brightscrip logo" />
  </div>
</div>
<div class="d-flex justify-content-center align-items-center">
  <div class="legalContentWrapper">
    <ng-content />
  </div>
</div>
